<template>
  <div class="selectCurrencyStyle">
    <v-select
      v-model="inputedValue"
      item-text="label"
      item-value="value"
      :items="items"
      dense
      outlined
      return-object
      class="original-selectbox"
      hide-details
      :placeholder="$t('common.input_unselected_2')"
      :height="height"
      :clearable="clearable"
    >
    </v-select>
  </div>
</template>

<script>
import { currencyUtil } from '@/util'

export default {
  components: {
    //
  },
  props: {
    value: {
      type: Object,
      require: true,
      default: () => ({})
    },
    height: { default: '32px' },
    clearable: { default: false }
  },
  data: () => ({
    items: []
  }),
  created() {
    this.items = currencyUtil.getCurrencyInfo()
  },
  methods: {
    //
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.selectCurrencyStyle {
  width: 100%;
}
</style>
